require('./bootstrap')

import Vue from 'vue'
window.Vue = Vue

import swal from 'sweetalert2'
window.swal = swal

import moment from 'moment'
window.moment = moment

require('select2')
// Perfect-Scrollbar - Minimalistic but perfect custom scrollbar plugin.  Learn more:  https://github.com/mdbootstrap/perfect-scrollbar
window.PerfectScrollbar = require('perfect-scrollbar/dist/perfect-scrollbar');
require('./scripts')
require('./config')
require('datatables.net-bs4')
require('bootstrap-datepicker')
require('./js-components')

const toast = swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
})
window.toast = toast

Vue.directive('select', {
    twoWay: true,
    bind: function (el, binding, vnode) {
        $(el).select2().on("select2:select", (e) => {
            // v-model looks for
            //  - an event named "change"
            //  - a value with property path "$event.target.value"
            el.dispatchEvent(new Event('change', { target: e.target }));
        });
    },
    update: function(el, nv, ov) {
        $(el).trigger("change");
    }
})

Vue.mixin({
    methods: {
        normalizeEval(formula, fixed = 3) {
            try {
                let total = eval(formula)
                if (total === undefined) {
                    total = `Rumus salah: ${formula}`
                } else if (total === Infinity || Number.isNaN(total)) {
                    total = 0
                } else {
                    total = (total).toFixed(fixed)
                }
                return total
            } catch (e) {
                console.log(e.message, formula)
                return formula
            }
        },
        alphabet(key) {
            var stringOfLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            var thisLoopAlpha = "",
                thisCode = 0;

            thisLoopAlpha = stringOfLetters[key];
            thisCode = thisLoopAlpha.charCodeAt(0);
            return String.fromCharCode( thisCode );
        },
        isNormalize(val) {
            return !Object.is(Infinity, val) && !Object.is(NaN, val) && !Object.is(null, val) && !Object.is("", val)
        },
        sum(values, fixed = 3) {
            let result = values.reduce((total, val) => {
                if (!this.isNormalize(total)) total = 0
                if (!this.isNormalize(val)) val = 0
                return parseFloat(total) + parseFloat(val)
            }, 0)
            if (!this.isNormalize(result)) result = 0
            return result.toFixed(fixed)
        },
        sum2Level(values) {
            let total = 0
            values.map((val, key) => {
                total += parseFloat(this.sum(val))
            })
            return total
        },
    }
})

Vue.component('example-component', require('./components/ExampleComponent.vue').default)
Vue.component('user-employee-info', require('./components/user/EmployeeInfo.vue').default)
Vue.component('template-form-data-detail-form', require('./components/template-form-data/TemplateFormDataDetailForm.vue').default)
Vue.component('template-report-blu-form', require('./components/template-report-blu/TemplateReportBluForm.vue').default)
Vue.component('template-report-blu-set-value-form', require('./components/template-report-blu/TemplateReportBluSetValueForm.vue').default)
Vue.component('template-report-blu-set-setting-form', require('./components/template-report-blu/TemplateReportBluSetSettingForm.vue').default)
Vue.component('template-report-rsb-form', require('./components/template-report-rsb/TemplateReportRsbForm.vue').default)
Vue.component('template-report-rsb-set-value-form', require('./components/template-report-rsb/TemplateReportRsbSetValueForm.vue').default)
Vue.component('template-report-rsb-set-setting-form', require('./components/template-report-rsb/TemplateReportRsbSetSettingForm.vue').default)
Vue.component('template-report-iki-form', require('./components/template-report-iki/TemplateReportIkiForm.vue').default)
Vue.component('template-report-iki-set-value-form', require('./components/template-report-iki/TemplateReportIkiSetValueForm.vue').default)
Vue.component('template-report-iki-set-setting-form', require('./components/template-report-iki/TemplateReportIkiSetSettingForm.vue').default)
Vue.component('template-report-ikt-form', require('./components/template-report-ikt/TemplateReportIktForm.vue').default)
Vue.component('template-report-ikt-set-value-form', require('./components/template-report-ikt/TemplateReportIktSetValueForm.vue').default)
Vue.component('template-report-ikt-set-setting-form', require('./components/template-report-ikt/TemplateReportIktSetSettingForm.vue').default)
Vue.component('input-form-data-form', require('./components/input-form-data/InputFormDataForm.vue').default)
Vue.component('input-form-data-view', require('./components/input-form-data/InputFormDataView.vue').default)
Vue.component('input-form-data-parent-view', require('./components/input-form-data/InputFormDataParentView.vue').default)
Vue.component('template-report-duplicate-form', require('./components/template-report/DuplicateTemplateForm.vue').default)
Vue.component('template-report-blu-delete-form', require('./components/template-report-blu/DeleteTemplateForm.vue').default)
Vue.component('report-recap-monthly-view', require('./components/report/recap-monthly/View.vue').default)
Vue.component('report-recap-monthly-parent-view', require('./components/report/recap-monthly/ParentView.vue').default)
Vue.component('template-report-priority-form', require('./components/template-report-priority/Form.vue').default)
Vue.component('template-report-national-form', require('./components/template-report-national/Form.vue').default)
Vue.component('home-priority-chart', require('./components/home/PriorityChart.vue').default)
Vue.component('home-national-chart', require('./components/home/NationalChart.vue').default)
Vue.component('export-input-form-data-parent-view', require('./components/input-form-data/ExportParentView.vue').default)
new Vue({
    el: "#app"
})
